// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperBrowserPreviewList-cls1_ROL","cls2":"PaperBrowserPreviewList-cls2_6Zt PaperBrowserPreviewList-cls1_ROL"};